var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('menu-button',{attrs:{"command":_vm.removeImage,"title":"Remove image","icon":"trashFull"}})
}
var staticRenderFns = []

export { render, staticRenderFns }